import RouteEnum from "constants/RouteEnum";
import React from "react";
import { Card, Row, Col } from "react-bootstrap";
import SottosezioneModel from "stores/contenuto/models/SottosezioneModel";
import BaseElement from "./BaseElement";

interface IProps {
    subsection: SottosezioneModel;
    background: string;
    redirectToPage: (page: RouteEnum) => void;
}
interface IState {}

class BaseSubsectionCard extends React.Component<IProps, IState> {
    public render(): JSX.Element {
        const { subsection, background, redirectToPage } = this.props;

        return (
            <Card className={"ccq-shadow h-100 " + background}>
                <Card.Body>
                    <Row className="d-flex h-100">
                        <Col md={12}>
                            {subsection.elementi.map((element, keyelement) => (
                                <BaseElement key={keyelement} element={element} redirectToPage={redirectToPage} />
                            ))}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        );
    }
}

export { BaseSubsectionCard as Unconnected };
export default BaseSubsectionCard;
